import React from "react";
import { loginWithGoogle, useAuth } from "../lib/auth";
import { Navigate } from "react-router-dom";

export default function Login() {
  const { user, loading } = useAuth();
  if (loading) return <div className="pt-40 container-w mono-label">Loading…</div>;
  if (user?.is_admin) return <Navigate to="/admin" replace />;

  return (
    <div data-testid="login-page" className="pt-28 md:pt-36 container-w min-h-[70vh]">
      <div className="max-w-md">
        <div className="mono-label mb-4">Studio · Admin</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight mb-6">Sign in.</h1>
        <p className="text-ash mb-10 leading-relaxed">Access the studio publishing tool. Restricted to studio members.</p>
        <button
          onClick={loginWithGoogle}
          data-testid="login-google"
          className="mono-label px-8 py-4 hairline text-marine hover:bg-marine hover:text-paper transition-colors duration-500"
        >
          Continue with Google →
        </button>
        {user && !user.is_admin && (
          <div className="mt-10 mono-label text-ash" data-testid="login-not-admin">
            You&rsquo;re signed in as {user.email}, but this account is not permitted studio access.
          </div>
        )}
      </div>
    </div>
  );
}
